import { AccordionHeader } from './accordion-header';
import { AccordionItem } from './accordion-item';
import { AccordionPanel } from './accordion-panel';
import { AccordionRoot } from './accordion-root';

export const Accordion = {
  Root: AccordionRoot,
  Item: AccordionItem,
  Header: AccordionHeader,
  Panel: AccordionPanel,
};
